module.exports = __webpack_public_path__ + "assets/fire.dbe46b54afa6b9625744d0621ace9764.png";